/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
// import {OPKey} from '../../../pages/configurator/orgFacility/orgInfo/constants/orgProfileKeyLabel';
// import useCompanyStore from '../../../store/companyStore/companyDetailsStore';
import useJSONStore from '../../../store/StaticJson/jsonStore';
import useUserStore from '../../../store/userStore/userStore';

const productsJSON = async (): Promise<any> => {
  const products = useJSONStore.getState().products;
  const token = useUserStore.getState().userToken;
  // const companyDetails = useCompanyStore.getState().companyDetails;
  const setProducts = useJSONStore.getState().setProducts;

  if (products.length === 0) {
    await axios
      .request({
        method: CRUDMethods.GET,
        url: `${API_BASE_URL}${API_ENDPOINT_JSON.JSON.products}`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {},
        data: {}
      })
      .then((res) => {
        setProducts(res.data.data);
      })
      .catch((err) => {
        return err.message;
      });
  }
};

export default productsJSON;
